export enum OrderStatus {
    PAYMENT_FAIL = 'payment_fail',
    PENDING = 'pending',
    CLINIC_ASSIGNED = 'clinic_assigned',
    ADMIN_APPROVAL_PENDING = 'admin_approval_pending',
    PATIENT_APPROVAL_PENDING = 'patient_approval_pending',
    DELIVERY_ASSIGNED = 'delivery_assigned',
    OUT_FOR_DELIVERY = 'out_for_delivery',
    DELIVERED = 'delivered',
    CANCELLED = 'cancelled',
    RETURNED_REQUESTED = 'returned_requested',
    RETURNED_ACCEPTED = 'returned_accepted',
    RETURNED_REJECTED = 'returned_rejected',
    RETURNED_COMPLETED = 'returned_completed'
}

export enum OrderType {
    DIRECT = 'direct',
    DIRECT_WITH_PRESCRIPTION = 'direct_with_prescription',
    PRESCRIPTION_BASED = 'prescription_based',
    LAB_TEST = 'lab_test'
}

export enum PaymentStatus {
    PENDING = 'pending',
    SUCCESS = 'success',
    FAILED = 'failed',
    REFUNDED = 'refunded'
}

export interface OrderListingDetails {
    data: OrderDetails[];
    pagination: {
        page: number,
        pageSize: number,
        totalCount: number,
        totalPages: number,
        hasNextPage: boolean,
        hasPrevPage: boolean
    }
}
export interface OrderDetails {
    orderId: number;
    orderNumber: string;
    patientId: string;
    orderType: string;
    orderDate: string;
    orderStatus: string;
    orderTotal: number;
    paymentId: string;
    paymentStatus: string;
    isPrescriptionRequired: boolean;
    hasPrescription: boolean;
    orderAddress: string;
    orderPincode: string;
    isLabTest: boolean;
    productDetails: ProductDetail[];
    clinicDetails: ClinicDetail;
    paymentDetails: PaymentDetail;
    prescriptionDetails: PrescriptionDetail[];
    deliveryPersonDetails: DeliveryPersonDetailsModel;
    patientDetails: PatientDetail;
    invoice:string;
    clinicId: string;
    createdAt: string;
    updatedAt: string;
}

export interface ProductDetail {
    productName: string;
    productImage: string;
    hsnNumber: string;
    cgst: string;
    sgst: string;
    pack: number;
    price: string;
    mrp: string;
    totalQuantity: number;
    productId:string
}

export interface ClinicDetail {
    clinicName: string;
    clinicProfileImage: string | null;
    clinicSupervisorName: string;
    clinicAddress: string;
    clinicPincode: string;
    clinicMobileNumber: string;
}

export interface PaymentDetail {
    paymentId: string;
    PaymentStatus: string;
    paymentAmount: number;
    paymentMethod: string;
    paymentDate: string;
    paymentFailureReason: string | null;
}

export interface PrescriptionDetail {
    id: number;
    source: string;
    prescriptionImage: string;
    note: string;
}

export interface PatientDetail {
    patientName: string;
    patientProfileImage: string;
    patientMobileNumber: string;
    patientAddress: string;
    patientPincode: string;
}

export interface DeliveryPersonDetailsModel {
    deliveryPersonName: string;
    deliveryPersonProfileImage: string | null;
    deliveryPersonMobileNumber: string;
    deliveryPersonVehicleNumber: string | null;
}

export interface Product {
    id: string;
    category_id: number;
    is_published: boolean;
    created_at: string;
    updated_at: string;
    description: string;
    name: string;
    is_rx_required: boolean;
    tablet_per_stripe: number;
    productImage: string;
}

export interface Manufacturer {
    id: string;
    manufacturer_name: string;
    created_at: string;
    updated_at: string;
}

export interface DispatchProduct {
    id: string;
    wholesaler_id: string;
    clinic_id: string;
    product_id: string;
    invoice_number: string;
    invoice_date: string;
    invoice_amount: string;
    manufacturer_id: string;
    marketer_id: string;
    expiry_date: string;
    batch_number: string;
    no_of_items: number;
    mrp: string;
    free_items: number;
    product_rate: string;
    discount: string;
    is_sp_updated: boolean;
    created_at: string;
    updated_at: string;
    landing_cost: string;
    remaining_stocks: number;
    hsn_number: string;
    cgst: string;
    sgst: string;
    sellingDiscount: string;
    finalSP: string;
    totalQuantity: number;
    salt: string;
    product: Product;
    manufacturer: Manufacturer;
}

export interface StockPagination {
    currentPage: number,
    itemsPerPage: number,
    totalItemsCount: number,
    totalPages: number,
    nextPage: number,
    previousPage: number
}

export interface ClinicStockResponse{
    data:DispatchProduct[]
    pagination:StockPagination
}

export interface SelectedProduct extends DispatchProduct{
    selectedQuantity:number
}